import * as z from "zod";
import { attachmentSchema, dateSchema } from "./schemasComplex";
import { zRequiredString } from "./schemaUtils";

export const schemaFormProject = z.object({
  eventType: z.literal("PROJECT"),
  name: zRequiredString("Veuillez dÃ©finir un nom").max(50, {
    message: "Maximum 50 caractÃ¨res",
  }),
  description: zRequiredString(
    "Veuillez dÃ©finir une description du projet",
  ),
  firstMeasure: zRequiredString(
    "Veuillez dÃ©finir une mesure immÃ©diate Ã  prendre",
  ),
  site: zRequiredString("Veuillez dÃ©finir un site"),
  localisation: z.string().optional(),
  dateEvt: dateSchema,
  attachedFiles: attachmentSchema,
  accessGivenTo: z.array(z.string()).optional(),
  accessRoleGivenTo: z.array(z.string()).optional(),
});
